import { PayloadAction } from '@reduxjs/toolkit'

import { AvatarState } from '../Types'
import { ExpressionItem } from 'store/Expressions/Types'

const updateMouth = (state: AvatarState, action: PayloadAction<ExpressionItem>) => {
    return {
        ...state,
        staged: {
            ...state.staged,
            mouth: {
                ...state.staged.mouth,
                expressionId: action.payload.expressionId,
                file: action.payload.file,
            },
        },
    }
}

export default updateMouth
